// extracted by mini-css-extract-plugin
export var arrow = "GalleryModule-module--arrow--ZLb-v";
export var arrowDisabled = "GalleryModule-module--arrowDisabled--Y4Z32";
export var arrowIcon = "GalleryModule-module--arrowIcon--xdNif";
export var arrowNext = "GalleryModule-module--arrowNext--eVAsk";
export var arrowPrev = "GalleryModule-module--arrowPrev--Zri3I";
export var autoPlayControlIcon = "GalleryModule-module--autoPlayControlIcon--8nQ+-";
export var autoplayControl = "GalleryModule-module--autoplayControl--k4Ckw";
export var autoplayControlWithCaption = "GalleryModule-module--autoplayControlWithCaption--admUV";
export var component = "GalleryModule-module--component--8dYLU";
export var dots = "GalleryModule-module--dots--wz5iG";
export var inner = "GalleryModule-module--inner--PQH01";